/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react'
import useApi from 'common/hooks/useApi'
import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers'
import moment from 'moment'
import { MenuItem, InputLabel, Box, Select, FormControl, Dialog, DialogTitle, Button, Chip } from '@mui/material';

function ProgramChip ({ api, data }) {
    const [athlete, setAthlete] = useState()
    const [program, setProgram] = useState()
    const [programList, setProgramList] = useState([])
    const [date, setDate] = useState(moment())
    const [assignButton, setAssignButton] = useState(null)
    const [open, setOpen] = useState(false);

    const [, programs] = useApi({url: 'metrics/program/program_list/'}, {manual: true})

    const handleClickOpen = () => {
        fetchData()
        setOpen(true);
    };

    const handleClose = (value) => {
        setOpen(false);
        setAssignButton(false)
    };

    const handleProgramChange = (event: SelectChangeEvent) => {
        setProgram(event.target.value);
    };

    const [{ loading: sendLoading }, sendAssign] = useApi(
        {
            method: 'POST',
            url: 'trainers/program/assign_athlete/',
        },
        { manual: true }
    )

    async function assignProgram() {
        const body = {
            'athlete': data.id,
            'id': program?.id,
            'name': program?.name,
            'tags': program?.tags,
            'start_date': date.format('YYYY-MM-DD'),
            'action': 'assign',
        }
        await sendAssign({
            data: body,
        })
        data.programs.push(program)
        handleClose()
        if (api){
            api.applyTransaction({ update: [data] })
        }
    }

    const [, removeProgram] = useApi(
            {
              method: 'POST',
              url: 'trainers/program/remove_athlete/',
            },
            { manual: true }
          )

    function deleteProgram(program, id) {

        const body = {
            'id': program.id,
            'athlete': id,
        }
        removeProgram({
            data: body,
        })
        const rowNode = api.getRowNode(data.id);
        let position = data.programs.indexOf(program);
        data.programs.splice(position, 1)
    }

    useEffect(() => {
        if(program){
            setAssignButton(true)
        }
    }, [program])

const fetchData = useCallback(
        async () => {
          const response = await programs()
          setProgramList(response?.data)
        }, [ programs]
    )

  return (
    <span>
        {data?.programs?.map((program, index) => (<Chip key={`${program.name}-${index}`} label={program.name} onDelete={() => deleteProgram(program, data?.id)}/>))}
        <Button onClick={handleClickOpen} style={{background: 'teal', color: 'white', minWidth: 30}}>+</Button>
        <Dialog
            onClose={handleClose}
            open={open}
            fullWidth={true}
            maxWidth={'lg'}
            >
            <DialogTitle>Assign Program to {data?.name}</DialogTitle>
          <Box style={{display: 'flex', justifyContent: 'center', padding: '40px'}}>
            <FormControl variant='outlined' style={{paddingRight: '20px', minWidth: '350px', width: '25%'}} >
            <InputLabel >Program</InputLabel>
                <Select
                  value={program}
                  onChange={handleProgramChange}
                >
                  {programList?.map((row) => (
                              <MenuItem value={row}>{row?.name}</MenuItem>
                          ))}
                </Select>
            </FormControl>
            <DatePicker
                style={{ paddingRight: '3%',  minWidth: '350px'}}
                format="YYYY-MM-DD"
                inputVariant="outlined"
                label="Start Date"
                name="start-date"
                value={date}
                onChange={(value) => setDate(value)}
            />
            <Button
                variant="contained"
                color="primary"
                style={{height: '55px', width: '100px', marginRight: '20px', marginLeft: '20px'}}
                onClick={assignProgram}
                disabled={!assignButton}
              >
              Assign
            </Button>
          </Box>
        </Dialog>
    </span>
  );
};

export default ProgramChip
